var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useRef } from 'react';
import { SupportedPaymentMethods } from '../../services/ApplicationSession';
import { AsurionDiv } from '../BaseComponents';
import styled from 'styled-components';
// Fix paypal processor weird padding defaults that are not consistent with the rest of the UI
var PaypalContainer = styled(AsurionDiv)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .adyen-checkout__paypal__status--processing {\n        padding: 0;\n    }\n"], ["\n    .adyen-checkout__paypal__status--processing {\n        padding: 0;\n    }\n"])));
var PayPal = function (props) {
    var payPalRef = useRef(null);
    var callback = function (state, component) {
        var _a, _b;
        props.onProcessing(true);
        var paypalInputForm = {
            paymentType: SupportedPaymentMethods.WEB_DROP_IN_PAYPAL,
            encryptedCustomerInput: state.data.paymentMethod,
            riskData: (_a = state.data) === null || _a === void 0 ? void 0 : _a.riskData
        };
        (_b = props === null || props === void 0 ? void 0 : props.onAuthorized) === null || _b === void 0 ? void 0 : _b.call(props, paypalInputForm, function (paymentAction) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                component.handleAction(paymentAction);
                component.setStatus('ready');
                return [2 /*return*/];
            });
        }); });
    };
    var onShopperDetails = function (shopperDetails, rawData, action) {
        var _a, _b, _c, _d;
        // update billingAddress in session config to return on onSuccess callback
        props.applicationSession.config.billingInformation = {
            address: {
                address1: (_a = shopperDetails === null || shopperDetails === void 0 ? void 0 : shopperDetails.billingAddress) === null || _a === void 0 ? void 0 : _a.street,
                city: (_b = shopperDetails === null || shopperDetails === void 0 ? void 0 : shopperDetails.billingAddress) === null || _b === void 0 ? void 0 : _b.city,
                postalCode: (_c = shopperDetails === null || shopperDetails === void 0 ? void 0 : shopperDetails.billingAddress) === null || _c === void 0 ? void 0 : _c.postalCode,
                stateOrProvince: (_d = shopperDetails === null || shopperDetails === void 0 ? void 0 : shopperDetails.billingAddress) === null || _d === void 0 ? void 0 : _d.stateOrProvince
            },
            contact: __assign({ email: shopperDetails === null || shopperDetails === void 0 ? void 0 : shopperDetails.shopperEmail }, shopperDetails === null || shopperDetails === void 0 ? void 0 : shopperDetails.shopperName)
        };
        action.resolve();
    };
    useEffect(function () {
        props.applicationSession.initializePayPal(payPalRef, callback, onShopperDetails, props.isPayPalAvailable, props.locale);
    }, []);
    return React.createElement(PaypalContainer, { ref: payPalRef, id: 'paypal-container' });
};
export default PayPal;
var templateObject_1;
